<template>
	<div class="nav search-menu-item">
		<div data-testid="globalsearch-section-area-name">
			<a
				class="search-menu-item__header"
				data-testid="globalsearch-section-link"
				target="_blank"
				:href="ultimateSearchLink"
				@click="handleClick"
				>{{ globalSearchSection.areaName }}</a
			>
		</div>
		<ul data-testid="globalsearch-section-area-items">
			<li
				class="search-menu-item__result-item"
				v-for="item in globalSearchSection.items"
				:key="item.link"
			>
				<a
					class="search-menu-item__result-item-link"
					data-testid="globalsearch-section-result-link"
					target="_blank"
					:href="item.link"
					@click="handleClick"
					><div>{{ item.description }}</div>
					<div v-if="item.companyName && item.sourceCompanyNumber">
						{{ item.companyName }} - ({{
							item.sourceCompanyNumber
						}})
					</div>
					<VueGlobalSearchSectionVehicle
						v-if="item.vehicle"
						:globalSearchSectionVehicle="item.vehicle"
					/>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
import VueGlobalSearchSectionVehicle from './vue-global-search-section-vehicle.vue';

export default {
	name: 'VueGlobalSearchSection',
	components: {
		VueGlobalSearchSectionVehicle
	},
	props: {
		globalSearchSection: {
			type: Object,
			default: undefined
		},
		ultimateSearchLink: {
			type: String,
			default: ''
		}
	},
	methods: {
		handleClick() {
			this.$emit('globalsearch-clicked-result');
		}
	}
};
</script>

<style scoped lang="scss">
.search-menu-item {
	background: var(--menu-list-bg);
	color: var(--menu-list-fg);

	&__header {
		@include heading(sm);
		display: inline-block;
		width: 100%;
		text-transform: uppercase;
		padding: $padding-md;

		&:hover {
			background: var(--menu-list-bg-hover);
			color: var(--menu-list-fg-hover);
		}

		@include header-focus-styles;
	}

	&__result-item-link {
		display: inline-block;
		padding: $padding-sm $padding-md;
		padding-left: 32px;
		width: 100%;
		height: 100%;

		&:hover {
			background: var(--menu-list-bg-hover);
			color: var(--menu-list-fg-hover);
		}

		@include header-focus-styles;
	}
}
</style>
